import { render, staticRenderFns } from "./VideoMonitor.vue?vue&type=template&id=2932e7c4&scoped=true"
import script from "./VideoMonitor.vue?vue&type=script&lang=js"
export * from "./VideoMonitor.vue?vue&type=script&lang=js"
import style0 from "./VideoMonitor.vue?vue&type=style&index=0&id=2932e7c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2932e7c4",
  null
  
)

export default component.exports